import axios from "axios"

class MainSpecialtyService {
  api
  constructor() {
    this.api = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}`,
    })
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem("Token")

      if (token) {
        config.headers = {
          Authorization: `Token ${token}`,
          withCredentials: false,
          "Content-Type": "application/json; charset=UTF-8",
        }
      }

      return config
    })
  }

  getMain_specialtyList = async () => {
    try {
      const response = await this.api.get(`/main-specialty/`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  getMain_specialtyDetails = async (main_specialtyId) => {
    try {
      const response = await this.api.get(
        `/main-specialty/${main_specialtyId}/`
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  createMain_specialty = async (main_specialtyData) => {
    try {
      const response = await this.api.post(
        `/main-specialty/`,
        main_specialtyData
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  updateMain_specialty = async (main_specialtyId, main_specialtyData) => {
    try {
      const response = await this.api.put(
        `/main-specialty/${main_specialtyId}/`,
        main_specialtyData
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  deleteMain_specialty = async (main_specialtyId) => {
    try {
      const response = await this.api.delete(
        `/main-specialty/${main_specialtyId}/`
      )
      return response.data
    } catch (error) {
      throw error
    }
  }
}

const mainSpecialtyService = new MainSpecialtyService()

export default mainSpecialtyService
